import request from '@/utils/request'

// 查询列表
export function listspecial(data) {
    return request({
      url: '/web_api/special/pop/list',
      method: 'post',
      data: data
    })
  }
  // 查询专题专栏列表
export function listcolumnZt(data) {
  return request({
    url: '/web_api/special/workZt/list',
    method: 'post',
    data: data
  })
}
export function infocolumnZt(id) {
  return request({
    url: '/web_api/special/workZt/'+ id,
    method: 'get',
  })
}